import { motion } from "framer-motion";

export default function Button({
  children,
  icon: Icon,
  loading = false,
  variant = "primary",
  type = "button",
  onClick,
  className = "",
}) {
  const variants = {
    primary: "bg-[#0A0F1A] text-white",
    accent: "bg-gradient-to-r from-[#3652FF] to-[#6D3AEB] text-white",
  };

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={loading}
      whileHover={
        !loading ? { y: -3, boxShadow: "0 14px 32px -10px rgba(54,82,255,0.55)" } : {}
      }
      whileTap={!loading ? { scale: 0.97, y: 0 } : {}}
      transition={{ type: "spring", stiffness: 420, damping: 22 }}
      className={`flex w-full items-center justify-center gap-2 rounded-md px-4 py-2.5
        text-sm font-semibold shadow-sm focus:outline-none focus-visible:ring-4 focus-visible:ring-white/20
        disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${className}`}
    >
      {loading ? (
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
      ) : (
        Icon && <Icon size={16} />
      )}
      {children}
    </motion.button>
  );
}